
import { Component, Prop, Vue } from "nuxt-property-decorator";
import SegmentedControl from "~/components/molecules/display/SegmentedControl.vue";
import OilImportTable from "~/components/organisms/table/OilImportTable.vue";

export interface TableRowItem {
  number?: number;
  text: string;
  href: string;
}

export type PelletRow = [TableRowItem | string, string, string, string];

interface Tab {
  label: string;
  key: "loose" | "pallet";
}

let tableSectionIdCounter = 0;

const TABS: Tab[] = [
  { label: "Lose Ware", key: "loose" },
  { label: "Sackware", key: "pallet" },
];

@Component({
  components: {
    SegmentedControl,
    OilImportTable,
  },
})
export default class PelletsTableSection extends Vue {
  @Prop({ required: true }) tableHeaderData!: string[];
  @Prop({ required: true }) looseRowData!: PelletRow[];
  @Prop({ required: true }) palletRowData!: PelletRow[];
  @Prop({ default: "" }) caption!: string;

  activeTabIndex = 0;
  instanceId = tableSectionIdCounter++;

  get tabIdPrefix(): string {
    return `pellets-tab-${this.instanceId}`;
  }

  get panelId(): string {
    return `pellets-tabpanel-${this.instanceId}`;
  }

  get activeTabId(): string {
    return `${this.tabIdPrefix}-${this.activeTabIndex}`;
  }

  get activeTab(): Tab {
    return TABS[this.activeTabIndex] ?? TABS[0];
  }

  get tabLabels(): string[] {
    return TABS.map((t) => t.label);
  }
}
